import { jsx as o } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { SimpleTreeView as d } from "@mui/x-tree-view/SimpleTreeView";
import t from "styled-components";
import { ExpandIcon as m, CollapseIcon as p } from "./icons.js";
import { getSize as c } from "./utils.js";
const w = {
  root: "treeViewRoot"
}, f = t.div.withConfig({
  displayName: "Root"
})([
  "height:calc(100% - 12px);width:100%;padding:6px 0px;"
]), h = t(d).withConfig({
  displayName: "StyledMuiTreeView"
})([
  "&.treeViewRoot{width:auto;min-width:100%;position:relative;background-color:",
  ";display:inline-block;}&&.treeViewRoot .treeItemContent,&&.treeViewRoot .treeItemContent:before{height:",
  ";}"
], ({ theme: e }) => e.primaryBackground, ({ $size: e }) => c(e)), V = /* @__PURE__ */ s(({ className: e, children: i, classes: r, size: a = "medium", ...n }, l) => /* @__PURE__ */ o(f, {
  className: e,
  children: /* @__PURE__ */ o(h, {
    classes: {
      ...w,
      ...r
    },
    ref: l,
    slots: {
      expandIcon: m,
      collapseIcon: p
    },
    ...n,
    $size: a,
    children: i
  })
}));
V.displayName = "TreeView";
export {
  V as default
};
